function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#1B1B1B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.084 12.98c0 3.662-2.97 6.633-6.634 6.633s-6.634-2.97-6.634-6.634 2.97-6.634 6.634-6.634 6.634 2.97 6.634 6.634zM8.582 34.672c0-6.002 4.866-10.868 10.868-10.868 6.002 0 10.868 4.866 10.868 10.868M80.541 26.07c0 3.663-2.97 6.634-6.634 6.634s-6.634-2.971-6.634-6.634c0-3.664 2.97-6.635 6.634-6.635s6.634 2.971 6.634 6.635zM63.04 47.762c0-6.002 4.865-10.868 10.867-10.868 6.003 0 10.868 4.866 10.868 10.868M43.626 64.556c0 3.664-2.97 6.634-6.634 6.634s-6.635-2.97-6.635-6.634 2.971-6.634 6.635-6.634c3.663 0 6.634 2.97 6.634 6.634zM26.124 86.249c0-6.002 4.865-10.868 10.868-10.868 6.002 0 10.868 4.866 10.868 10.868",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.646 18.995c.25 10.6-8.14 19.398-18.74 19.65-10.601.252-19.4-8.137-19.65-18.74C.004 9.306 8.394.509 18.995.256c10.6-.251 19.399 8.138 19.65 18.74zM92.98 32.34c.252 10.6-8.138 19.397-18.74 19.65-10.6.252-19.398-8.139-19.65-18.74-.252-10.6 8.139-19.398 18.74-19.65 10.6-.252 19.399 8.138 19.65 18.74zM55.878 71.245c.252 10.602-8.138 19.399-18.739 19.65-10.6.252-19.399-8.137-19.65-18.738-.253-10.601 8.137-19.398 18.74-19.65 10.6-.252 19.398 8.137 19.65 18.738zM26.503 40.732l2.706 9.687M41.602 24.238l10.56 2.182M50.154 53.735l6.195-6.807",
  transform: "translate(1 1)"
}));

var SvgThreePeople = function SvgThreePeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 94,
    viewBox: "0 0 96 94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThreePeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/three-people.c7beb8fb.svg";
export { ForwardRef as ReactComponent };